import RequestBuilder from '../Lib/Requests';

export default class ValidationErrorsService {
  api = new RequestBuilder();

  buildValidationErrorsRequest(gatewayID, params, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/gateway/${gatewayID}/error`,
      method: 'get',
      params,
      cancelToken,
    };
  }

  async fetchValidationErrors(gatewayID, params, cancelToken) {
    const { data } = await this.api.request(
      this.buildValidationErrorsRequest(gatewayID, params, cancelToken)
    );
    return data;
  }
}
